import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  featureFlags: ['data'],

  initializeAppSuccess: ['data'],
  initializeAppError: ['error'],

  sendCampaignRequest: ['data'],
  sendCampaignSuccess: ['data'],
  sendCampaignError: ['error'],

  ssrRender: ['bool'],
  modalRequest: ['props'],
  feedbackRequest: ['props'],

  openSearchBox: ['opened'],

  setClientPlataform: ['plataform'],

  refreshServicesRequest: ['service'],
  refreshServicesSuccess: ['data'],
  refreshServicesError: ['error'],

  footerRequest: [],
  footerSuccess: ['data'],
  footerError: ['error'],

  menuCategoryRequest: ['siteId'],
  menuCategorySuccess: ['data'],
  menuCategoryError: ['error'],

  setCookiesPolicy: ['data'],

  seoRequest: ['page'],
  seoSuccess: ['data'],
  seoError: ['error'],
});

const INITIAL_STATE = Immutable({
  config: { theme: {}, positions: [], defaultSEO: {} },
  modal: {},
  feedback: {},
  ssrRender: !global.window,
  header: {},
  footer: {},
  error: {},
  refreshResult: {},
  isLoading: false,
  cookiesPolicy: { show: true, accepted: true },
  seo: {},
  featureFlags: {},
});

const initializeFeatureFlags = (state = INITIAL_STATE, { data: featureFlags }) => state.merge({ featureFlags });

const ssrRender = (state = INITIAL_STATE, { bool }) => state.set('ssrRender', bool);

const request = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const requestError = (state = INITIAL_STATE, { error }) => state.merge({ isLoading: false, error });

const initializeAppSuccess = (state = INITIAL_STATE, { data }) => state.merge(data, { deep: true });

const initializeAppError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const openSearchBox = (state = INITIAL_STATE, { opened }) => state.setIn(['header', 'openSearchBox'], opened);

const refreshServicesRequest = (state = INITIAL_STATE, { service }) =>
  state.merge({ refreshResult: {}, [`${service}IsLoading`]: true, error: {} });

const refreshServicesSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);

const refreshServicesError = (state = INITIAL_STATE, { error }) => state.merge(error);

const sendCampaignSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);

const setClientPlataform = (state = INITIAL_STATE, { size }) => state.merge({ size });

const footerSuccess = (state = INITIAL_STATE, { data }) => state.merge({ data });

const menuCategorySuccess = (state = INITIAL_STATE, { data }) => state.merge(data);

const setCookiesPolicy = (state = INITIAL_STATE, { data }) => state.set('cookiesPolicy', data);

const modalRequest = (state = INITIAL_STATE, { props }) => state.set('modal', props);

const feedbackRequest = (state = INITIAL_STATE, { props }) => state.set('feedback', props);

const seoSuccess = (state = INITIAL_STATE, { data }) => state.set('seo', data);

export default createReducer(INITIAL_STATE, {
  [Types.FEATURE_FLAGS]: initializeFeatureFlags,

  [Types.SSR_RENDER]: ssrRender,
  [Types.MODAL_REQUEST]: modalRequest,
  [Types.FEEDBACK_REQUEST]: feedbackRequest,

  [Types.OPEN_SEARCH_BOX]: openSearchBox,

  [Types.SET_CLIENT_PLATAFORM]: setClientPlataform,

  [Types.INITIALIZE_APP_SUCCESS]: initializeAppSuccess,
  [Types.INITIALIZE_APP_ERROR]: initializeAppError,

  [Types.REFRESH_SERVICES_REQUEST]: refreshServicesRequest,
  [Types.REFRESH_SERVICES_SUCCESS]: refreshServicesSuccess,
  [Types.REFRESH_SERVICES_ERROR]: refreshServicesError,

  [Types.SEND_CAMPAIGN_REQUEST]: request,
  [Types.SEND_CAMPAIGN_SUCCESS]: sendCampaignSuccess,
  [Types.SEND_CAMPAIGN_ERROR]: requestError,

  [Types.FOOTER_REQUEST]: request,
  [Types.FOOTER_SUCCESS]: footerSuccess,
  [Types.FOOTER_ERROR]: requestError,

  [Types.SEO_REQUEST]: request,
  [Types.SEO_SUCCESS]: seoSuccess,
  [Types.SEO_ERROR]: requestError,

  [Types.MENU_CATEGORY_REQUEST]: request,
  [Types.MENU_CATEGORY_SUCCESS]: menuCategorySuccess,
  [Types.MENU_CATEGORY_ERROR]: requestError,

  [Types.SET_COOKIES_POLICY]: setCookiesPolicy,
});
